package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_04_26_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have just survived Obraxus’s ambush and killed him. They have traveled deep into this supposed shortcut and contemplate backtracking to the well-established winding path. Korvis takes a moment to get his bearings, and then advises the heroes that they forge on across the rough terrain. Falorn brags that he knew the shortcut was real from the beginning. The heroes regret killing Obraxus before they could interrogate him. Falorn suggests that after a long rest and some quiet prayer and meditation, he could speak with the dead. The heroes load Obraxus’s corpse onto the cart and continue North. They encounter several physical obstacles for the cart but overcome them with ingenuity and a touch of magic.")
    }
}
